// @flow
import * as React from 'react';
import Button from 'app/common/react/components/growth/unauth/Button/Button';
import i18n from 'app/common/lib/i18n';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { Box } from 'gestalt';

type Props = {
  numServerRenderedPins?: number,
  clientJsActive?: boolean,
  handleImageClick: Function,
  repinCount?: number,
  socialTextExpGroup?: string,
  viewButtonStyleOverrides?: ?{
    fontSize?: string,
  },
  textOverride?: string,
  disableHoverText?: boolean,
};

const styles = {
  container: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
  },
  visitButton: {
    cursor: 'pointer',
    display: 'flex',
    margin: 'auto',
    background: 'transparent',
    border: 'none',
    color: '#ffF',
    fontSize: '32px',
    fontWeight: '700',
    outline: 'none',
    paddingLeft: '8px',
    paddingRight: '8px',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
};

const PinImageHover = ({
  numServerRenderedPins,
  clientJsActive,
  disableHoverText,
  handleImageClick,
  repinCount,
  socialTextExpGroup,
  textOverride,
  viewButtonStyleOverrides,
}: Props) => {
  const renderViewButton = () => {
    if (!numServerRenderedPins || (numServerRenderedPins > 0 && clientJsActive)) {
      const visitButtonStyle = viewButtonStyleOverrides
        ? { ...styles.visitButton, ...viewButtonStyleOverrides }
        : styles.visitButton;
      return (
        <Button
          className={'noButtonStyles'}
          onClick={(e) => {
            e.stopPropagation();
            trackRegisterAction('unauth.pin_image_hover_view_click');
            handleImageClick(e);
          }}
          styleOverrides={visitButtonStyle}
        >
          {!disableHoverText && (
            <Box display="flex" direction="column" alignItems="center">
              {textOverride ||
                i18n._(
                  'View',
                  "Text on a pin leading to a close up view. This is for users who don't have an account on Pinterest.",
                )}
            </Box>
          )}
        </Button>
      );
    }
    return null;
  };

  return (
    <Box
      position="absolute"
      top
      right
      bottom
      left
      display="flex"
      alignContent="center"
      alignItems="center"
    >
      {renderViewButton()}
    </Box>
  );
};

export default PinImageHover;
